import { useAppStateStore } from '#/hooks/useAppStateStore';

export const useCanEditSelectedReservation = (showEdit: boolean = false) => {
    const appStore = useAppStateStore();

    return showEdit && appStore.isSelectedReservationEditable;
};
